import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import './index.css';
import './App.css';
import Navigation from "./components/Navigation";
import Footer from './components/Footer';
import { CryptoProvider } from "./context/CryptoContext";
import { StorageProvider } from "./context/StorageContext";
import { TrendingProvider } from "./context/TrendingContext";

import { useEffect } from 'react';

// Import Pages
import Home from './components/HomeComponent';
import Crypto from './pages/Crypto';
import Trending from './pages/Trending';
import Saved from './pages/Saved';
import CryptoDetails from './components/CryptoDetails';
import CryptoWallet from './pages/CryptoWallet';
import { ByCategory } from './components/ByCategory';
import TelegramNavigation from './components/TelegramNavigation';

// Create a wrapper component to use location hook
const Main = () => {
  const location = useLocation();

  // Get query parameters
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get('source');

  // Determine if the current path is for coin details
  const isCoinDetailsPage = /^\/[^/]+$/.test(location.pathname);

  useEffect(() => {
    // Conditionally change the body background color
    if (source === 'telegram') {
      document.body.style.backgroundColor = '#131313'; // Set Telegram-specific color
    }

    // Clean up function to reset the background when component unmounts
    return () => {
      document.body.style.backgroundColor = ''; // Reset to original color
    };
  }, [source]);

  return (
    <>
      {/* Render Navigation only if not sourced from Telegram */}
      {source !== 'telegram' && <Navigation />}
      {source === 'telegram' && <TelegramNavigation />}

      <Routes>
        <Route path="/" element={source === 'telegram' ? <CryptoWallet /> : <Home />} />
        <Route path="/crypto" element={<Crypto source={source} />} />
        <Route path="/trending" element={<Trending />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/:coinId" element={<CryptoDetails />} />
        <Route path="/category/:category" element={<ByCategory />} />
        <Route path="/?source=telegram" element={<CryptoWallet />} />
      </Routes>

      {/* Render Footer only if not sourced from Telegram and not on coin details page */}
      {source !== 'telegram' && !isCoinDetailsPage && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <CryptoProvider>
      <TrendingProvider>
        <StorageProvider>
          <main className="w-full flex flex-col content-center items-center relative text-white font-nunito overflow-x-hidden">
            <Router>
              <Main />
            </Router>
          </main>
        </StorageProvider>
      </TrendingProvider>
    </CryptoProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
